

















import Vue from 'vue';

interface Navigator {
  standalone: boolean;
}
export default Vue.extend({
  name: 'AddMeToHome',

  data: () => {
    // show add me popup only once (iOS & Safari app)
    const home = location.search.indexOf('homescreen') !== -1;
    const standalone = (window.navigator as any).standalone;
    const userAgent = window.navigator.userAgent.toLowerCase();
    const safari = /safari/.test(userAgent);
    const ios = /iphone|ipod|ipad/.test(userAgent);
    return { visible: !home && !standalone && safari && ios };
  },

  methods: {
    hide() {
      this.visible = false;
    },
  },
});
